import { Divider } from "@mui/material";
import React from "react";
import useCheckPermission from "../../../common/hooks/useCheckPermission";
import ExportExcelButton from "./ExportExcelButton";
import ExportPdfButton from "./ExportPdfButton";

const ExportSection = ({
  exportApi = "",
  filterValues = null,
  showDivider = false,
}) => {
  return (
    <>
      {useCheckPermission("excel") ? (
        <>
          <ExportExcelButton
            exportApi={exportApi}
            filterValues={filterValues}
          />

          {showDivider ? (
            <Divider
              orientation="vertical"
              variant="middle"
              flexItem
              sx={{ mx: 1 }}
            />
          ) : null}
        </>
      ) : null}

      {useCheckPermission("pdf") ? (
        <>
          <ExportPdfButton exportApi={exportApi} filterValues={filterValues} />

          {showDivider ? (
            <Divider
              orientation="vertical"
              variant="middle"
              flexItem
              sx={{ mx: 1 }}
            />
          ) : null}
        </>
      ) : null}
    </>
  );
};

export default ExportSection;
